import { registerComponent } from '../app'
import { OPEN_MENU, CLOSE_MENU, OPEN_CART } from '../events'

const Menu = (scope, el) => {
	const props = {
		openClass: 'open'
	}

	function open() {
		window.requestAnimationFrame(() => el.classList.add(props.openClass))
	}

	function close() {
		window.requestAnimationFrame(() => el.classList.remove(props.openClass))
	}

	scope.on(OPEN_MENU, () => {
		open()
	})

	scope.on(CLOSE_MENU, () => {
		close()
	})

	scope.on(OPEN_CART, () => {
		scope.emit(CLOSE_MENU)
	})
}

registerComponent('menu', Menu)
